import React, { Component } from 'react';
import { withFormik } from 'formik';
import Yup from 'yup';
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components';
import 'intl-tel-input/build/css/intlTelInput.css';
import * as intlTelInputUtils from 'intl-tel-input/build/js/utils.js';
import * as intlTelInput from 'intl-tel-input';
// import MediaQuery from 'react-responsive';

import FormikForm from '../../components/Form/FormikForm';
import TextInput from '../../components/Form/TextInputUX';
import TextInputTooltip from '../../components/Form/TextInputTooltip';
import CheckboxInput from '../../components/Form/CheckboxInput';
import GoogleRecaptcha from '../../components/Form/GoogleRecaptcha';
import ButtonWrapper from '../../components/Form/ButtonWrapper';
import Button from '../../collections/Button/Button';
import FaInfoCircle from 'react-icons/lib/fa/info-circle';
import { media } from '../../utilities/style-utilities';
import ReactGA from 'react-ga';

const errorMap= ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

const SizedInfoCircle = styled(FaInfoCircle)`
  font-size: 1.5rem;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1rem;
  ${ media.desktop`
    flex-direction: column;
  `}
`;

const FlexRowItem = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  & div.iti {
    width:100%;
  }
`;

var instance;

class CardActivationForm extends Component {

  // constructor(props) {
  //   super(props);
  // };
  componentDidMount() {
    var input = document.querySelector("#phone");
    instance = intlTelInput(input,{
      initialCountry: 'gb'
    });
  };

  componentWillReceiveProps(nextProps) {
    let prompt = (this.props.isSubmitting === false && this.props.dirty === true);
    if (prompt !== this.props.form) {
      this.props.handleFormPrompt(prompt);
    }
    if (this.props.defaultValues !== nextProps.defaultValues) {
      this.props.resetForm({
        name: '',
        serialNumber: '',
        email: '',
        confirmEmail: '',
        mobileNumber:'',
        terms: false,
        recaptcha: ''
      });
      window.grecaptcha.reset();
    }
  }

  sendEvent = (category, action, label) => {
      ReactGA.event({
          category: category,
          action: action,
          label: label
      })
  }

  render() {
    const {
      // values,
      // touched,
      errors,
      dirty,
      isSubmitting,
      // handleChange,
      // handleBlur,
      // handleSubmit,
      // handleReset,
      setFieldValue
    } = this.props;

    const sitekey = process.env.REACT_APP_GOOGLE_RECAPTCHA;

    this.sendEvent('CardActivation', 'Journey', 'CardActivationCardCredentials');
    return (
      <FormikForm>

        <FlexRow>
          <FlexRowItem>
            <TextInput name="name"
              type={this.props.appState.ui.cardActivation.formValidation.name.inputType} 
              label={this.props.appState.ui.cardActivation.formValidation.name.label} 
              placeholder={this.props.appState.ui.cardActivation.formValidation.name.placeholder}
            />

            <TextInputTooltip 
              name="serialNumber"
              type={this.props.appState.ui.cardActivation.formValidation.serialNumber.inputType}
              label={this.props.appState.ui.cardActivation.formValidation.serialNumber.label} 
              placeholder={this.props.appState.ui.cardActivation.formValidation.serialNumber.placeholder} 
              icon={<SizedInfoCircle/>}
              companyLogo={this.props.appState.ui.cardActivation.tooltip.serialNumber.imageSrc}
              companyAlt={this.props.appState.ui.cardActivation.tooltip.serialNumber.imageAlt}
              type={this.props.appState.ui.cardActivation.tooltip.serialNumber.type}
              // companyMessage={this.props.ui.cardActivation.tooltip.serialNumber.message}
            />

            <TextInput
              name="email"
              type={this.props.appState.ui.cardActivation.formValidation.email.inputType}
              label={this.props.appState.ui.cardActivation.formValidation.email.label} 
              placeholder={this.props.appState.ui.cardActivation.formValidation.email.placeholder} 
            />

            <TextInput
              name="confirmEmail"
              type={this.props.appState.ui.cardActivation.formValidation.confirmEmail.inputType}
              label={this.props.appState.ui.cardActivation.formValidation.confirmEmail.label} 
              placeholder={this.props.appState.ui.cardActivation.formValidation.confirmEmail.placeholder}
              autoComplete="off"
              handlePaste={(event) => event.preventDefault()} 
            />

            <TextInputTooltip
               name="MobileNumber"
               type={this.props.appState.ui.cardActivation.formValidation.mobileNumber.inputType}
               id={this.props.appState.ui.cardActivation.formValidation.mobileNumber.id}
               icon={<SizedInfoCircle/>}
               messageTitle={this.props.appState.ui.cardActivation.tooltip.mobileNumber.messageTitle}
               message={this.props.appState.ui.cardActivation.tooltip.mobileNumber.message}
               type={this.props.appState.ui.cardActivation.tooltip.mobileNumber.type}
            />
          </FlexRowItem>
        </FlexRow>

        <CheckboxInput name="terms" label="Accept terms and conditions - " link={'click here to view'} checked={this.props.values.terms} url={this.props.url} textColor={this.props.appState.ui.cardActivation.card.titleTextColor}/>

        <GoogleRecaptcha sitekey={sitekey} size="normal" onChange={(response) => { setFieldValue("recaptcha", response); }}/>

        <ButtonWrapper>
          <Button 
            color={this.props.appState.ui.cardActivation.buttons.backward.textColor} 
            background={this.props.appState.ui.cardActivation.buttons.backward.backgroundColor} 
            border={this.props.appState.ui.cardActivation.buttons.backward.borderColor} 
            type="button"
            role="button"
            onClick={this.props.backHandler}>
              {this.props.appState.ui.cardActivation.buttons.backward.text}
          </Button>
          <Button 
            color={this.props.appState.ui.cardActivation.buttons.forward.textColor} 
            background={this.props.appState.ui.cardActivation.buttons.forward.backgroundColor}
            border={this.props.appState.ui.cardActivation.buttons.forward.borderColor} 
            type="submit" 
            role="button"
            disabled={isSubmitting || !isEmpty(errors) || !dirty}>
              {this.props.appState.ui.cardActivation.buttons.forward.text}
          </Button>
        </ButtonWrapper>

      </FormikForm>
    );
  }
};



const EnhancedForm = withFormik({

  mapPropsToValues: (props) => ({
    name: '',
    serialNumber: '',
    email: '',
    confirmEmail: '',
    MobileNumber:'',
    terms: false,
    recaptcha: '',
  }),

  // mapPropsToValues: (props) => {
  //   let values = {};
  //   Object.keys(props.ui.cardActivation.formValidation).map((value) => {
  //     return values[value] = '';
  //   }) 
  //   return values;
  // },

  enableReinitialize: true,

  validationSchema: (props) => { return Yup.object().shape({
    name: Yup.string()
      .matches(new RegExp(props.appState.ui.cardActivation.formValidation.name.regex), props.appState.ui.cardActivation.formValidation.name.regexMessage)
      .max(21, "This field has a maximum allowed character limit of 21.")
      .required(props.appState.ui.cardActivation.formValidation.name.requiredMessage),
    serialNumber: Yup.string()
      .matches(new RegExp(props.appState.ui.cardActivation.formValidation.serialNumber.regex), props.appState.ui.cardActivation.formValidation.serialNumber.regexMessage)
      .min(props.appState.ui.cardActivation.formValidation.serialNumber.validLength, props.appState.ui.cardActivation.formValidation.serialNumber.validLengthMessage)
      .max(props.appState.ui.cardActivation.formValidation.serialNumber.validLength, props.appState.ui.cardActivation.formValidation.serialNumber.validLengthMessage)
      .required(props.appState.ui.cardActivation.formValidation.serialNumber.requiredMessage),
    email: Yup.string()
      .email(props.appState.ui.cardActivation.formValidation.email.regexMessage)
      .max(50, "This field has a maximum allowed character limit of 50.")
      .required(props.appState.ui.cardActivation.formValidation.email.requiredMessage),
    confirmEmail: Yup.string()
      .oneOf([Yup.ref('email'), null], props.appState.ui.cardActivation.formValidation.confirmEmail.invalid)
      .email(props.appState.ui.cardActivation.formValidation.email.regexMessage)
      .required(props.appState.ui.cardActivation.formValidation.confirmEmail.requiredMessage),
    MobileNumber: Yup.string()
        .test(`Phone number Validation`, errorMap[instance.getValidationError()],
              function() {
               return instance.isValidNumber();
              })
        .required(props.appState.ui.cardActivation.formValidation.mobileNumber.requiredMessage),
    terms: Yup.bool()
      .oneOf([true], props.appState.ui.cardActivation.formValidation.terms.requiredMessage)
      .required(props.appState.ui.cardActivation.formValidation.terms.requiredMessage),
    recaptcha: Yup.string()
      .required()
  })},

  handleSubmit: (values, { props, setSubmitting }) => {
    values.MobileNumber = instance.getNumber();
    setSubmitting(true);
    props.update({loading: true});
    props.handleErrorMessage(false, '');
    props.api.getCheckCardDetails(values.serialNumber, values.name, values.email,16, true)
      .then(response => {
        if (response !== null) {
          props.update({
            cardDetails: response,
            session: values
          }, (state) => {
            if (state.cardDetails.ExtranetSiteRuleId !== null) {
              props.api.getExtranetSiteRulesWithId(state.cardDetails.ExtranetSiteRuleId, 'en-gb')
                .then(response => {
                  let settings = response.Settings;
                  props.update({
                    code: response.Code, 
                    ui: JSON.parse(settings[0].Value),
                    settings: {
                      culture: settings[0].CultureCode,
                      csskey: settings[1].Value,
                      emailTemplate: settings[2].Value,
                      emailPayload: settings[3].Value,
                      terms: settings[4].ResourceUrl
                      // terms: `${props.url === '/' ? window.location.origin + props.url +'terms' : window.location.origin + props.url + '/terms'}`
                    },
                    siteRules: response
                  }, (state) => {
                    let route = props.validateCodeAndReturnRoute(state.code);
                    if (state.cardDetails.ActivTransID === 6) {
                      
                      switch (state.cardDetails.PpsAccountStatus) {
                        case 'I': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'A': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'S': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently suspended and therefore cannot be used.`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'card-activation'))
                          })
                          break;
                        case 'B': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently blocked and therefore cannot be used.`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'card-activation'))
                          })
                          break;
                        default:
                          props.handleCardStatus(state, route, setSubmitting)
                      }
                    } else {
                      setSubmitting(false);
                      props.handleErrorMessage(true, `Unfortunately, your card cannot be activated online. You will need to activate your card via our automated telephone service. To do this you will need both your card and activation code letter (which you will have received previously). Please call 03334000018 and select the 'Card Activation' option from the menu. You will then be asked to quote your 16 digit card number and the activation code detailed on your activation letter. You will then be issued a 4 digit PIN number.`);
                      props.update({
                        route: {
                          schema: route.schema,
                          client: route.client,
                        },
                        loading: false
                      }, (state) => {
                        props.history.push(props.generateURIFromCode(state.code, 'card-activation'))
                      })
                    }

                  });
                })
                .catch(error => {
                  setSubmitting(false);
                  props.update({loading: false});
                  props.handleErrorMessage(true, `Server responded with error: ${error}`);
                  // console.error('Server responded with error for getExtranetSiteRulesWithId', error);
                });
            } else {
              props.api.getExtranetSiteRulesWithId(1, 'en-gb')
                .then(response => {
                  let settings = response.Settings;
                  props.update({
                    code: response.Code, 
                    ui: JSON.parse(settings[0].Value),
                    settings: {
                      culture: settings[0].CultureCode,
                      csskey: settings[1].Value,
                      emailTemplate: settings[2].Value,
                      emailPayload: settings[3].Value,
                      terms: settings[4].ResourceUrl
                      // terms: `${props.url === '/' ? window.location.origin + props.url +'terms' : window.location.origin + props.url + '/terms'}`
                    },
                    siteRules: response
                  }, (state) => {
                    let route = props.validateCodeAndReturnRoute(state.code);

                    if (state.cardDetails.ActivTransID === 6) {
                      switch (state.cardDetails.PpsAccountStatus) {
                        case 'I': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'A': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'S': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently suspended and therefore cannot be used.`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'card-activation'))
                          })
                          break;
                        case 'B': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently blocked and therefore cannot be used.`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'card-activation'))
                          })
                          break;
                        default:
                          props.handleCardStatus(state, route, setSubmitting)
                      }
                    } else {
                      
                      setSubmitting(false);
                      props.handleErrorMessage(true, `Unfortunately, your card cannot be activated online. You will need to activate your card via our automated telephone service. To do this you will need both your card and activation code letter (which you will have received previously). Please call 03334000018 and select the 'Card Activation' option from the menu. You will then be asked to quote your 16 digit card number and the activation code detailed on your activation letter. You will then be issued a 4 digit PIN number.`);
                      props.update({
                        route: {
                          schema: route.schema,
                          client: route.client,
                        },
                        loading: false
                      }, (state) => {
                        props.history.push(props.generateURIFromCode(state.code, 'card-activation'))
                      })
                    }
                    
                  });
                })
                .catch(error => {
                  setSubmitting(false);
                  props.update({loading: false});
                  props.handleErrorMessage(true, `Server responded with error: ${error}`);
                  // console.error('Server responded with error for getExtranetSiteRulesWithId', error);
                });
            }
          });
        } else {
          setSubmitting(false);
          props.update({session: values, loading: false})
          if (props.attempts < 3) {
            props.handleMultipleAttempts();
            props.handleErrorMessage(true, `The name or card serial number does not match what we have, please re-enter.`);
          } else {
            props.handleErrorMessage(true, `You have attempted to provide a card serial number unsuccessfully three times or more. The serial number can be found on the back of the card in the top right hand corner starting with the number 8.`);
          }
        }
      })
      .catch(error => {
        setSubmitting(false);
        props.update({loading: false});
        props.handleErrorMessage(true, `Server responded with ${error}`);
        // console.error('Server responded with error', error);
      });
  },

  displayName: 'CardActivationStep1', // helps with React DevTools
})(CardActivationForm);


export default EnhancedForm;


// WEBPACK FOOTER //
// ./src/containers/CardActivationPage/Step1.js